import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import JetCourierCookieStatement from '../../components/JetCourierCookieStatement';
import JetCourierTechListing from '../../components/JetCourierTechListings';

export const JetCourierLayout = () => {
  const JetCourierPrivacyPolicies = React.lazy(
    () => import('@src/apps/JetCourierStatements/components/JetCourierPrivacyPolicies')
  );

  return (
    <Router basename="/apps/jetcourier">
      <Switch>
        <Route exact path="/privacy-statement">
          <JetCourierPrivacyPolicies />
        </Route>
        <Route exact path="/cookie-statement">
          <JetCourierCookieStatement />
        </Route>
        <Route exact path="/technology-list">
          <JetCourierTechListing />
        </Route>
        <Route exact path="*">
          <Redirect to="/privacy-statement" />
        </Route>
      </Switch>
    </Router>
  );
};
